import { GoogleVoice, type GoogleVoiceJson } from "./GoogleVoice";
import type { Language } from "./Language";
import type { LanguageCollection } from "./LanguageCollection";
import { Service, type ServiceJson } from "./Service";
import { Voice } from "./Voice";

export interface SpeechServiceJson extends ServiceJson {
  shortEngineName: string;
  voices: Record<string, GoogleVoiceJson>;
  defaultVoices: Record<string, string>;
}

export class SpeechService extends Service {
  // TODO clearer distinction between SpeechService and a new class GoogleSpeechService,
  // as we have in in Java and as we have with GoogleVoice.
  shortEngineName: string;
  voices: Record<string, Voice>;
  defaultVoices: Record<string, Voice>;

  constructor(json: SpeechServiceJson, allLanguages: LanguageCollection) {
    super(json, allLanguages);
    this.voices = {};
    for (const [voiceName, voiceJson] of Object.entries(json.voices || {})) {
      this.voices[voiceName] = new GoogleVoice(voiceJson, allLanguages, this);
    }
    this.defaultVoices = {};
    for (const [languageTag, voiceName] of Object.entries(
      json.defaultVoices || {}
    )) {
      this.defaultVoices[languageTag] = this.voices[voiceName]!;
    }
    this.shortEngineName = json.shortEngineName;
  }

  getVoiceByName(voiceName: string): Voice | undefined {
    let parts = voiceName.split("/");
    if (parts.length > 2) {
      console.error("Voice name must consist of one part (unqualified) or two parts (qualified), separated be a slash. Given voiceName was '" + voiceName + "'.");
    } else {
      if (parts.length == 2) {
        let serviceName = parts[0]!;
        if (this.names.includes(serviceName)) {
          console.error("You cannot request a qualified voice for service '" + serviceName + "' from this service which responds to the names " + this.names + ", preferably to " + this.shortEngineName);
        }
        voiceName = parts[1]!;
      }
    }

    if (this.voices) {
      return this.voices[voiceName];
    }
    return undefined;
  }

  getDefaultVoiceForLanguage(language?: Language): Voice | undefined {
    if (language) {
      return this.defaultVoices[language.toString()];
    }
    return undefined;
  }

  getVoicesForLanguage(language: Language): Array<Voice> {
    return Object.values(this.voices).filter(voice => voice.languages.has(language?.toString()));
  }
}
